import { ScUtils } from 'smartcommerce-component-library'
import BaseObservable from '../utils/BaseObservable'

class BusyService extends BaseObservable {
  ids = []

  busy (id) {
    id = id || ScUtils.methods.generateId()
    this.ids.push(id)
    this.notify(true)
    return id
  }

  finished (id) {
    this.ids.splice(this.ids.indexOf(id), 1)
    this.notify(this.ids.length > 0)
  }
}

export default new BusyService()
